import { useContent } from "@/content/ContentProvider";

export default function Marquee() {
  const marqueeItems = useContent("home.marqueeItems");

  return (
    <div className="overflow-hidden border-y border-foreground-950/10 bg-primary-500 py-4">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((clone) => (
          <div key={clone} className="flex items-center">
            {marqueeItems.map((item) => (
              <span key={`${clone}-${item}`} className="flex items-center">
                <span className="whitespace-nowrap px-6 font-heading text-base font-black tracking-tight text-foreground-950 md:text-lg">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-foreground-950/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}